import styled from 'styled-components';
import * as COLORS from 'Constants/colors';

export default DesktopPackageSearch => styled(DesktopPackageSearch)`
  display: block;
  min-height: 20px;
  max-width: 1140px;
  width: 100%;

  .tags-holder {
    display: flex;
    flex-direction: row-reverse;
  }

  .package-search_bottom-card {
    margin: 8px 0 6px;
  }

  .form-item {
    display: flex;
    align-items: center;
    margin-right: 10px;

    label {
      margin: 0;
      white-space: nowrap;
      margin-right: 8px;
    }

    &.top-margin {
      margin-top: 8px;
    }

    &.to-right {
      justify-content: flex-end;
    }

    .form-item_label-holder {
      margin-right: 8px;
    }

    &.space-between {
      justify-content: space-between;
    }
  }

  .package-search_top-card {
    background-color: ${COLORS.white};
    border-radius: 0 0 14px 14px;
    box-shadow: 0 2px 14px rgba(49, 23, 75, 0.12);
    overflow: hidden;

    .package-search-tabs_holder {
      display: flex;

      .package-search-tabs_item {
        transition: 0.2s;
        cursor: pointer;
        height: 40px;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;

        &.active {
          background-color: ${COLORS.important};
          box-shadow: ${COLORS.shadows.three};
        }
      }
    }

    .package-search-options_holder {
      min-height: 156px;
      box-shadow: inset 0 -1px 0 rgba(49, 23, 75, 0.08);
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 12px 0;

      .icons-list {
        display: flex;
        justify-content: space-evenly;
        align-items: center;

        &.wrap {
          flex-wrap: wrap;
        }
      }

      .package-search-icon {
        width: 108px;

        .package-search-icon_title {
          font-size: 13px;
          height: 34px;
          line-height: 17px;
          margin-bottom: 4px;
          width: 108px;
        }

        .package-search-icon_container.regular {
          height: 74px;
          margin-bottom: 6px;
          margin-top: 0;
          width: 74px;
        }

        .package-search-icon_container.small {
          height: 44px;
          width: 44px;
        }

        &.small {
          height: 48px;
          width: 48px;
        }
      }
    }
  }

  @media screen and (max-width: 1140px) {
    width: 90%;

    .package-search_top-card {
      .package-search-options_holder {
        max-height: 180px;

        .icons-list_holder {
          overflow-y: auto;
          margin: 0 5px;
          display: flex;
          justify-content: center;
          align-items: center;

          .icons-list {
            display: flex;
            justify-content: center;
            align-items: center;

            &.wrap {
              flex-wrap: nowrap;
            }
          }
        }
      }
    }
  }
`;
